// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"15c2ebc5","453":"699ec0a5","455":"307ea484","977":"28f0f072"}[chunkId] + ".chunk.js";
};